import {App} from '@capacitor/app'
import {Capacitor, PluginListenerHandle} from '@capacitor/core'
import {useEffect, useRef} from 'react'
import {useNavigate} from 'react-router-dom'

// Adds an app listener which pushes deep links onto the history stack.
const useDeepLinkHandler = () => {
  const navigate = useNavigate()
  const listenerRef = useRef<PluginListenerHandle>()
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return
    App.addListener('appUrlOpen', ({url}) => {
      const {hostname, pathname, search} = new URL(url)
      if (hostname === window.location.hostname) {
        navigate(`${pathname}${search}`)
      }
    }).then(listener => {
      listenerRef.current = listener
    })
    return () => {
      listenerRef.current?.remove()
    }
  })
}

export default useDeepLinkHandler
